import { useNavigate } from 'react-router-dom'
import { useTVStore } from '@/shared/store'
import { useTopMenu } from '@/widgets/TopMenu/hooks/useTopMenu'
import { useAnalytics } from '@/app/context/AnalyticsContext/AnalyticsContext'
import { tvPagePath } from '@/shared/constants'
import useChannelChangeHook from '@/components/tv/hooks/useChannelChangeHook'

export const useExternalLinkHandlerStreamIQ = () => {
    const navigate = useNavigate()
    const { channelsData } = useTVStore()
    const { handleTvClick } = useTopMenu()
    const { handleChannelChange } = useChannelChangeHook()
    const Analytics = useAnalytics()

    const handleExternalLink = (channelId: string) => {
        if (channelId) {
            const channel = channelsData.find(
                (channel) => channel.id === channelId
            )
            if (channel) {
                handleTvClick()
                navigate(tvPagePath)
                handleChannelChange(channel)
            }
        }

        Analytics?.analyticsLogEvent('deeplink_item_click', {
            to: `streamIQ channel${channelId}`,
        })
    }

    return { handleExternalLink }
}
